export const endpoints = {
  SPACES: "/space/view",
  FOLDERS: "/folder/view",
  LISTS: "/list/view",
  TASKS: "/task/view",
  TASKS_UPDATE: "/task/update",
  TASKS_CREATE: "/task/create"
};
